<template>
	<div class="t-avatar" :style="style">
		<div class="t-avatar-character">{{firstLetter}}</div>
	</div>
</template>

<script>
export default {
	props: {
		hue: {
			type: [String, Number],
			default: 100
		},
		name: {
			type: String
		},
		size: {
			type: [String, Number],
			default: 30
		}
	},
	computed: {
		style() {
			return {
				'--hue': this.hue,
				'font-size': `${this.size}px`
			};
		},
		firstLetter() {
			return this.name.charAt(0);
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/text';
.t-avatar {
	height: 1em;
	width: 1em;
	--hue: 100;
	display: flex;
	align-items: center;
	justify-content: center;
	background: hsl(var(--hue), 70%, 90%);
	border-radius: 100%;
	&-character {
		@extend %font-families-display;
		font-weight: bold;
		line-height: 0;
		color: hsl(var(--hue), 70%, 30%);
		font-size:0.6em;
	}
}
</style>

<docs>
```jsx
<div style="display: grid; grid-auto-flow: column; grid-column-gap: 10px; height: 100px; grid-auto-columns: minmax(min-content, max-content);">
	<t-avatar name="Ivar"/>
	<t-avatar name="Anon" hue="200" size="40"/>
	<t-avatar name="Per" hue="300" size="50"/>
	<t-avatar name="Anne" hue="0" size="60"/>
</div>
```
</docs>